// extracted by mini-css-extract-plugin
module.exports = {"root":"SquareModal_root__1_Tmw","title":"SquareModal_title__28KcA","description":"SquareModal_description__1rB2_"};